import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import "./LoginPage.css";

import { FiEye, FiEyeOff, FiLock, FiArrowLeft } from "react-icons/fi";
import { LuUserRound } from "react-icons/lu";
import logo from "../../assets/layout_img/logo.png";

function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = location.state?.from?.pathname || "/";

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [serverError, setServerError] = useState("");
  const [errorFields, setErrorFields] = useState({
    username: false,
    password: false,
  });

  const validate = () => {
    const errs = {
      username: username.trim() === "",
      password: password.trim() === "",
    };
    setErrorFields(errs);
    return !(errs.username || errs.password);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerError("");

    if (!validate()) return;

    const formData = new FormData();
    formData.append("Username", username);
    formData.append("Password", password);

    try {
      const res = await fetch(
        "https://algoritm-api-edu.uz/api/public/Auth/Login",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await res.json().catch(() => null);

      if (!res.ok) {
        const err =
          data?.title ||
          Object.values(data?.errors || {})
            .flat()
            .join(". ") ||
          "Login muvaffaqiyatsiz.";
        return setServerError(err);
      }

      const token = data.accessToken || data.token;
      if (!token) return setServerError("Token topilmadi!");

      let decoded;
      try {
        decoded = jwtDecode(token);
      } catch {
        return setServerError("Token xato. Qayta urinib ko‘ring.");
      }

      const role =
        decoded[
          "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
        ]?.toLowerCase();

      if (!role) return setServerError("Foydalanuvchi roli aniqlanmadi!");

      localStorage.setItem("accessToken", token);
      localStorage.setItem("refreshToken", data.refreshToken || "");
      localStorage.setItem("userRole", role);
      localStorage.setItem(
        "userName",
        decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"] ||
          username
      );

      if (role === "admin" || role === "administrator")
        return navigate("/admin/subjects");

      if (role === "teacher") return navigate("/teacher");

      if (role === "student") return navigate("/student");

      return setServerError("Bu rolga ruxsat berilmagan!");
    } catch (e) {
      console.error(e);
      setServerError("Internet yoki server xatosi.");
    }
  };

  return (
    <div className="login-page">
      <div className="login-back" onClick={() => navigate("/")}>
        <FiArrowLeft />
      </div>

      <form className="login-form" onSubmit={handleSubmit}>
        <img src={logo} alt="Login Logo" className="login-form_img" />

        <div className={`input-group ${errorFields.username ? "error" : ""}`}>
          <LuUserRound className="input-icon" />
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => {
              setUsername(e.target.value);
              setErrorFields({ ...errorFields, username: false });
            }}
          />
        </div>

        <div className={`input-group ${errorFields.password ? "error" : ""}`}>
          <FiLock className="input-icon" />
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setErrorFields({ ...errorFields, password: false });
            }}
          />

          <span
            className="toggle-password"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FiEyeOff /> : <FiEye />}
          </span>
        </div>

        {serverError && <p className="error-message">{serverError}</p>}

        <button type="submit">Login</button>
      </form>
    </div>
  );
}

export default LoginPage;
